import { getItemsFromCollection } from "directus/src/operations";

export async function fetchDedicatedJobConfig({ jobId }) {
  try {
    const query = {
      fields: ["id", "cost", "currency", "paid_leaves", "budget_margin"],
      filter: {
        job: {
          _eq: jobId,
        },
      },
    };

    const response = await getItemsFromCollection(
      "dedicated_job_config",
      query,
    );

    const item = response[0];
    if (item) {
      if (typeof item.cost === "string") item.cost = Number(item.cost);
      if (typeof item.paid_leaves === "string") item.paid_leaves = Number(item.paid_leaves);
    }

    return item;
  } catch (error) {
    console.error("Error fetching dedicated config:", error);
    throw error;
  }
}
